import React, { useEffect } from "react";
import "./TableAdCopies.css";
import AdCopies from "./AdCopies";
import { useSelector } from "react-redux";
import FacebookIcon from "../../../assets/images/facebook.svg";
import { PuffLoader } from "react-spinners";

const TableAdCopis = ({ campaign }) => {
  const campaignDetails = useSelector((state) => state.campaigns.campaign);
  const loading = useSelector((state) => state.campaigns.adCopiesLoading);

  return (
    <div className="tableAdCopies">
      <div className="tableAdCopies-heading">
        <h4>Your ad creatives</h4>
      </div>
      <div className="adCopiesFlex">
        {loading && (
          <div style={{ width: "100%", height: "15rem", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <PuffLoader size={80} color="#0F6EFF" />
          </div>
        )}
        {!loading &&
          campaignDetails?.ad_preview_data?.map((item, i) => {
            return (
              <AdCopies
                adPreviewLink={item?.adPreviewLink}
                pageName={campaign?.fb_page_name || ""}
                profilePic={campaign?.fb_profile_picture || FacebookIcon}
                caption={item?.adCaption}
                thumbnail={item?.adImage}
              />
            );
          })}
      </div>
    </div>
  );
};

export default TableAdCopis;
